import React from "react";
import Nav from "../components/Nav";
import Hero from "../components/Hero";
import Experience from "../components/Experience";
import Projects from "../components/Projects";
import Writings from "../components/Writings";
import Footer from "../components/Footer";

function HomeScreen() {
  return (
    <div>
      <Nav />
      <div className="max-w-3xl mx-auto px-8">
        <Hero />
        <Experience />
        <Projects />
        <Writings />
      </div>
      <Footer />
    </div>
  );
}

export default HomeScreen;
